/** ms before a press-and-hold becomes a long-press */
export const LONG_PRESS_DURATION_MS = 500;
export const LONG_PRESS_MOVE_THRESHOLD_PX = 10;

/** Magic Flow webhook polling — exponential backoff with cap */
export const POLLING = {
  INITIAL_INTERVAL: 1000,
  MAX_INTERVAL: 8000,
  BACKOFF_FACTOR: 1.5,
  MAX_ATTEMPTS: 150,
};
